module.exports = __webpack_public_path__ + "img/menu_01.927d6049.png";